// Mounted document tabs keep their own filters and reload after a resolved write.
const listeners = new Set<() => void>();

export function subscribeDocumentChanges(listener: () => void): () => void {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function notifyDocumentChanged(): void {
  for (const listener of listeners) listener();
}
